import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "row"]

  connect() {
    this.highlight()
  }

  highlight() {
    const selectedKey = this.selectTarget.value

    this.rowTargets.forEach((row) => {
      row.classList.toggle("bg-blue-50", row.dataset.navCalculationTypeKey === selectedKey)
    })
  }
}
